import { Container, Icon, Text } from "@jds/core";
//css
import classes from "./Accordion.module.css";
import { useState } from "react";

const Accordion = ({ show, toggleItem, data }) => {
  return (
    <div className={classes["acc-container"]}>
      <Container fullWidth direction="column">
        {/* title */}
        <Container
          fullWidth
          horizontalAlign={"space-between"}
          verticalAlign="center"
          style={{
            marginBottom: "12px",
          }}
        >
          <Text text={`${data?.title}`} appearance="body-m-bold" />
          <Icon ic={show ? "IcMinus" : "IcAdd"} onClick={toggleItem} />
        </Container>
        {/* main content */}
        <Container
          fullWidth
          direction={"row"}
          style={{ flexWrap: "wrap", columnGap: "120px", rowGap: "20px" }}
        >
          {data?.mainCard?.map((item, index) => (
            <Container direction="column" gap={8} key={index}>
              <Text
                text={`${item.title}`}
                color="primary_grey_80"
                appearance="body-s-bold"
              />
              <Text text={`${item.value}`} appearance="body-l-bold" />
            </Container>
          ))}
        </Container>
        {/* content */}

        <div
          className={show ? `${classes.contentShow}` : `${classes.contentHide}`}
        >
          <Container
            fullWidth
            style={{
              marginTop: "20px",
              paddingBlock: "20px",
              borderTop: "2px solid #E0E0E0",
            }}
          >
            {data?.subCard?.map((item, index) => (
              <Container
                key={index}
                fullWidth
                direction="column"
                gap={16}
                style={{
                  paddingRight: "20px",
                  marginRight: "20px",
                }}
              >
                {item?.map((val) => (
                  <>
                    <Container>
                      <Container gap={12} verticalAlign="center">
                        <Icon
                          ic={`${val.icon}`}
                          kind="background"
                          size="large"
                        />
                        <Text text={`${val.title}`} appearance="body-m-bold" />
                      </Container>
                    </Container>

                    {/* count data */}
                    <Container fullWidth direction="column">
                      {val?.value?.map((data) => (
                        <Container
                          fullWidth
                          horizontalAlign={"space-between"}
                          verticalAlign="center"
                        >
                          <Text
                            text={`${data?.title}`}
                            color="primary_grey_80"
                            appearance="body-s-bold"
                          />
                          <Text
                            text={`${data?.value}`}
                            appearance="body-s-bold"
                          />
                        </Container>
                      ))}
                    </Container>
                  </>
                ))}
              </Container>
            ))}
          </Container>
        </div>
      </Container>
    </div>
  );
};

export default Accordion;
